<template>
    <div class="field is-horizontal">
        <div class="field-body">
            <div class="display-flex">
                <label class="radio upcoming-radio">
                    <input type="radio" :value="false" v-model="auctionType">
                    Upcoming
                </label>

                <label class="radio past-radio">
                    <input type="radio" :value="true" v-model="auctionType">
                    Past Auction Result
                </label>

            </div>


        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            auctionType: {
                get() {
                    return this.$store.getters.getStatsStatus
                },
                set(value) {
                    this.$store.dispatch('setStatsStatus', value)
                }
            }
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/AuctionType.vue